import React, { useCallback, useState, useEffect, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import PhiSanXuatApi from "service/QuanLyMuaBan/PhiSanXuatApi";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import NumberFormat from "react-number-format";
import { ModalXacNhanItem } from "./ModalXacNhanItem";
import { formatNumber } from "utils/currencyFormat";
import { getDate, formatDateV2 } from "utils/formatDate";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import ReactDropdown from "react-dropdown";
import OrderApi from "service/OrderApi";
import TaiSanApi from "service/taiSanApi";

const TableLichSuPhiSanXuat = ({ list, onEditItem, onDeleteItem }) => {
    return (
        <div className="Table-main-new">
            <div className="table-mobile table-mobile-hover">
                <div className="custom-table-wrapper">
                    <div className="table-headers" >
                        <div className="custom-table-header" style={{ width: '15%' }}><p>Ngày</p></div>
                        <div className="custom-table-header" style={{ width: '20%' }}><p>Tên tài sản</p></div>
                        <div className="custom-table-header" style={{ width: '30%' }}><p>Thông tin tài sản</p></div>
                        <div className="custom-table-header" style={{ width: '15%', justifyContent: 'center' }}><p>Ghi chú</p></div>
                        <div className="custom-table-header text-right" style={{ width: '10%', justifyContent: 'flex-end' }}><p>Phí SX</p></div>
                        <div className="custom-table-header text-center" style={{ width: '10%' }}><p>Thao tác</p></div>
                    </div>
                    <div className="custom-table-body">
                        {list.length === 0 ? (
                            <div className="custom-table-row">
                                <div className="custom-table-cell text-center" style={{ width: "100%" }}>
                                    Chưa có lịch sử phí sản xuất.
                                </div>
                            </div>
                        ) : (
                            list.map((item, index) => (
                                <div className="custom-table-row" key={item.PhiSXID || index}>
                                    <div className="custom-table-cell" style={{ width: '15%' }}><span className="mobile-column-name">Ngày</span>{getDate(item.NgayNhap)}</div>
                                    <div className="custom-table-cell" style={{ width: '20%' }}><span className="mobile-column-name">Tên tài sản</span>{item.TenTaiSan}</div>
                                    <div className="custom-table-cell" style={{ width: '30%' }}><span className="mobile-column-name">Thông tin</span>{item.ThongTinTaiSan}</div>
                                    <div className="custom-table-cell" style={{ width: '15%', justifyContent: 'center' }}><span className="mobile-column-name">Ghi chú</span>{item.GhiChu}</div>
                                    <div className="custom-table-cell text-right" style={{ width: '10%', justifyContent: 'flex-end' }}>
                                        <span className="mobile-column-name">Phí SX</span>{formatNumber(item.PhiSanXuat)}
                                    </div>
                                    <div className="custom-table-cell text-center" style={{ width: '10%', justifyContent: 'center' }}>
                                        <span className="mobile-column-name">Thao tác</span>
                                        <a className="iconTableMorman" title="Sửa phí này" onClick={() => onEditItem(item)}>
                                            <img src="/app-assets/images/icon-button-edit-v2.png" alt="Sửa" style={{ width: 16 }} />
                                        </a>
                                        &nbsp;
                                        <a className="iconTableMorman" title="Xóa phí này" onClick={() => onDeleteItem(item)}>
                                            <img src="/app-assets/images/icon-xoa-v2.png" alt="Xóa" style={{ width: 16 }} />
                                        </a>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const ModalPhiSanXuat = ({ orderId, onClose }) => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [editingPhiSXID, setEditingPhiSXID] = useState(0);
    const [khachHang, setKhachHang] = useState({ CustomerName: "", CustomerPhone: "", CustomerAddress: "" });
    const [danhSachTaiSan, setDanhSachTaiSan] = useState([]);
    const [lichSuPhiSanXuat, setLichSuPhiSanXuat] = useState([]);
    const [NgayNhap, setNgayNhap] = useState(new Date());
    const [TaiSanID, setTaiSanID] = useState(0);
    const [TongTienNhap, setTongTienNhap] = useState(0);
    const [PhiSanXuat, setPhiSanXuat] = useState(0);
    const [GhiChu, setGhiChu] = useState("");
    const [showConfirmXoa, setShowConfirmXoa] = useState(false);
    const [deletingPhiSXID, setDeletingPhiSXID] = useState(0);
    const [deletingTenTaiSan, setDeletingTenTaiSan] = useState("");
    const [thuocTinhTaiSan, setThuocTinhTaiSan] = useState([]);
    const [loadingThuocTinh, setLoadingThuocTinh] = useState(false);

    const loadAllData = useCallback(() => {
        if (!orderId) return;
        setLoading(true);
        Promise.all([
            OrderApi.getThongTinDonHang(orderId),
            TaiSanApi.getTaiSan(orderId),
            PhiSanXuatApi.getLichSuPhiSanXuat(orderId)
        ])
            .then(([resKhachHang, resTaiSan, resLichSu]) => {
                if (resKhachHang.status === 200 && resKhachHang.data) {
                    setKhachHang(resKhachHang.data || {});
                }
                if (resTaiSan.status === 200 && resTaiSan.data) {
                    const assets = resTaiSan.data || [];
                    setDanhSachTaiSan(assets);
                    let currentTaiSanId = 0;
                    if (currentTaiSanId === 0 && assets.length > 0) {
                        currentTaiSanId = assets[0].TaiSanID;
                    }
                    if (currentTaiSanId > 0) {
                        setTaiSanID(currentTaiSanId);
                        const selectedAsset = assets.find(ts => ts.TaiSanID === currentTaiSanId);
                        setTongTienNhap(selectedAsset ? selectedAsset.TongTienNhap : 0);
                        loadThuocTinh(currentTaiSanId);
                    }
                }
                if (resLichSu.status === 200 && resLichSu.data) {
                    setLichSuPhiSanXuat(resLichSu.data || []);
                }
            })
            .catch(err => {
                console.error("Lỗi load dữ liệu Phí sản xuất:", err);
                pushNotification("Lỗi tải dữ liệu", "error");
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        loadAllData();
    }, []);

    const resetForm = () => {
        setEditingPhiSXID(0);
        setPhiSanXuat(0);
        setGhiChu("");
        setNgayNhap(new Date());
        loadThuocTinh(TaiSanID);
    };
    const loadThuocTinh = (taiSanId) => {
        if (taiSanId === 0) {
            setThuocTinhTaiSan([]);
            return;
        }
        setLoadingThuocTinh(true);
        TaiSanApi.getThuocTinhChoTaiSan(taiSanId)
            .then(res => {
                if (res.status === 200) {
                    setThuocTinhTaiSan(res.data || []);
                } else {
                    setThuocTinhTaiSan([]);
                }
            })
            .catch(err => {
                console.error("Lỗi load thuộc tính:", err);
                setThuocTinhTaiSan([]);
            })
            .finally(() => {
                setLoadingThuocTinh(false);
            });
    };
    const handleSavePhiSanXuat = () => {
        if (TaiSanID === 0) {
            pushNotification("Vui lòng chọn tài sản", "error");
            return;
        }
        if (PhiSanXuat <= 0 && editingPhiSXID === 0) {
            pushNotification("Vui lòng nhập phí sản xuất", "error");
            return;
        }
        setSaving(true);
        const payload = {
            PhiSXID: editingPhiSXID,
            OrderID: orderId,
            TaiSanID: TaiSanID,
            TenKhachHang: khachHang.CustomerName,
            NgayNhap: formatDateV2(NgayNhap),
            PhiSanXuat: PhiSanXuat,
            GhiChu: GhiChu,
        };
        PhiSanXuatApi.luuPhiSanXuat(payload)
            .then(res => {
                if (res.status === 200) {
                    pushNotification(res.data.Message || "Lưu thành công", "success");
                    resetForm();
                    PhiSanXuatApi.getLichSuPhiSanXuat(orderId).then(resLS => {
                        if (resLS.status === 200) setLichSuPhiSanXuat(resLS.data || []);
                    });
                } else {
                    pushNotification(res.message || "Lưu thất bại", "error");
                }
            })
            .catch(err => {
                console.error("Lỗi lưu phí sản xuất:", err);
                const errMsg = err.response?.data?.Message || err.message || "Lỗi máy chủ";
                pushNotification(errMsg, "error");
            })
            .finally(() => {
                setSaving(false);
            });
    };

    const handleEditItem = (item) => {
        setEditingPhiSXID(item.PhiSXID);
        setNgayNhap(new Date(item.NgayNhap));
        setTaiSanID(item.TaiSanID);
        setPhiSanXuat(item.PhiSanXuat);
        setGhiChu(item.GhiChu);
        const selectedAsset = danhSachTaiSan.find(ts => ts.TaiSanID === item.TaiSanID);
        setTongTienNhap(selectedAsset ? selectedAsset.TongTienNhap : 0);
        loadThuocTinh(item.TaiSanID);
    };

    const handleDeleteItem = (item) => {
        setDeletingPhiSXID(item.PhiSXID);
        setDeletingTenTaiSan(item.TenTaiSan);
        setShowConfirmXoa(true);
    };

    const confirmDelete = () => {
        if (deletingPhiSXID === 0) return;
        return PhiSanXuatApi.xoaPhiSanXuat(deletingPhiSXID)
            .then(res => {
                if (res.status === 200) {
                    pushNotification("Xóa phí thành công", "success");
                    PhiSanXuatApi.getLichSuPhiSanXuat(orderId).then(resLS => {
                        if (resLS.status === 200) setLichSuPhiSanXuat(resLS.data || []);
                    });
                } else {
                    pushNotification(res.message || "Xóa thất bại", "error");
                }
            })
            .catch(err => {
                console.error("Lỗi xóa phí:", err);
                const errMsg = err.response?.data || err.message || "Lỗi máy chủ";
                pushNotification(errMsg, "error");
            });
    };
    const taiSanOptions = useMemo(() => {
        const options = danhSachTaiSan.map(ts => ({
            value: ts.TaiSanID,
            label: ts.TenTaiSan
        }));
        return [{ value: 0, label: "--- Chọn tài sản ---" }, ...options];
    }, [danhSachTaiSan]);
    const handleDropdownTaiSanChange = (option) => {
        const selectedId = option.value;
        setTaiSanID(selectedId);
        const selectedAsset = danhSachTaiSan.find(ts => ts.TaiSanID === selectedId);
        setTongTienNhap(selectedAsset ? selectedAsset.TongTienNhap : 0);
        loadThuocTinh(selectedId);
    };
    return (
        <>
            <Modal
                show={true}
                size="new-size"
                centered
                className="modal-new modal fade text-left popup-detail"
                animation={true}
                style={{ zIndex: 1050 }}
            >
                {!showConfirmXoa && (
                    <>
                        <Modal.Header>
                            <h4 className="modal-title">
                                <span className="btn-icon-right">
                                    <img src="/app-assets/images/icon-dolla-v2.png" alt="logo" style={{ width: 24, height: 24 }} />
                                </span>
                                <span style={{ fontWeight: "bold" }}>Phí sản xuất</span>
                            </h4>
                            <button type="button" className="close-popup-new" onClick={() => onClose(true)} disabled={saving}>
                                <i className="mdi mdi-close"></i>
                            </button>
                        </Modal.Header>
                        <Modal.Body>
                            {loading && <div className="loader loader-default is-active"></div>}

                            <h3 className="lead collapsed" style={{ paddingBottom: "5px", color: "#00B69B", fontWeight: "bold" }}>Thông tin khách hàng</h3>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Tên khách hàng</label>
                                        <input type="text" className="form-control" value={khachHang.CustomerName || ""} disabled />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Số điện thoại</label>
                                        <input type="text" className="form-control" value={khachHang.CustomerPhone || ""} disabled />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Địa chỉ</label>
                                        <input type="text" className="form-control" value={khachHang.CustomerAddress || ""} disabled />
                                    </div>
                                </div>
                            </div>
                            <h3 className="lead collapsed" style={{ paddingBottom: "5px", color: "#00B69B", fontWeight: "bold" }}>Tài sản mua</h3>
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Ngày tạo</label>
                                        <DateTimePicker
                                            id="NgayNhapPhi"
                                            value={NgayNhap}
                                            onChange={setNgayNhap}
                                            className="form-control input-sm"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Tên tài sản <span className="text-danger">(*)</span></label>
                                        <ReactDropdown
                                            options={taiSanOptions}
                                            onChange={handleDropdownTaiSanChange}
                                            value={taiSanOptions.find(opt => opt.value === TaiSanID)}
                                            controlClassName="form-control input-sm"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Tổng tiền nhập</label>
                                        <NumberFormat
                                            className="form-control"
                                            value={TongTienNhap}
                                            thousandSeparator=","
                                            displayType="input"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Phí sản xuất <span className="text-danger">(*)</span></label>
                                        <NumberFormat
                                            className="form-control"
                                            placeholder="Nhập phí sản xuất"
                                            value={PhiSanXuat}
                                            thousandSeparator=","
                                            onValueChange={(values) => setPhiSanXuat(values.floatValue || 0)}
                                            allowNegative={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Ghi chú</label>
                                        <textarea
                                            className="form-control1 input-sm"
                                            placeholder="Nhập nội dung ghi chú"
                                            value={GhiChu}
                                            onChange={(e) => setGhiChu(e.target.value)}
                                            rows={2}
                                            style={{ width: "100%" }}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                            <h3 className="lead collapsed" style={{ paddingBottom: "5px", color: "#00B69B", fontWeight: "bold" }}>Thông tin tài sản</h3>
                            <div className="row">
                                {loadingThuocTinh ? (
                                    <div className="col-md-12 text-center">Đang tải thuộc tính...</div>
                                ) : (
                                    thuocTinhTaiSan.map((item, index) => (
                                        <div className="col-md-3" key={index}>
                                            <TextInputOnRow
                                                labelClass="label-control text-bold"
                                                inputClass="form-control input-sm"
                                                wrapperClass="form-group"
                                                labelText={item.TenThuocTinh}
                                                inputProps={{
                                                    value: item.GiaTri,
                                                    disabled: true
                                                }}
                                            ></TextInputOnRow>
                                        </div>
                                    ))
                                )}
                            </div>
                            <h3 className="lead collapsed" style={{ paddingBottom: "5px", color: "#00B69B", fontWeight: "bold" }}>Lịch sử phí sản xuất</h3>
                            <TableLichSuPhiSanXuat
                                list={lichSuPhiSanXuat}
                                onEditItem={handleEditItem}
                                onDeleteItem={handleDeleteItem}
                            />
                        </Modal.Body>

                        <Modal.Footer>
                            <button className="btn btn-new-main btn-closenew" onClick={() => onClose(true)} disabled={saving}>
                                <i className="mdi mdi-close"></i>&nbsp; Đóng
                            </button>
                            <button
                                className="btn"
                                disabled={saving || loading || TaiSanID === 0}
                                style={{ background: "#056569", color: "white", borderRadius: "6px", fontSize: "15px", textTransform: "none" }}
                                onClick={handleSavePhiSanXuat}
                            >
                                {saving ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm"></span>&nbsp; Đang lưu...
                                    </>
                                ) : (
                                    <>
                                        <img src="/app-assets/images/icon-add-v2.png" />&nbsp; {editingPhiSXID === 0 ? "Lưu lại" : "Cập nhật"}
                                    </>
                                )}
                            </button>
                        </Modal.Footer>
                    </>
                )}
            </Modal>
            {showConfirmXoa && (
                <ModalXacNhanItem
                    show={showConfirmXoa}
                    onHide={() => {
                        setShowConfirmXoa(false);
                        setDeletingPhiSXID(0);
                    }}
                    onConfirm={confirmDelete}
                    title="Xác nhận xóa phí"
                    message={`Bạn có chắc chắn muốn xóa phí của tài sản "${deletingTenTaiSan}"?`}
                />
            )}
        </>
    );
}

export default ModalPhiSanXuat;